import { Directive, Input, TemplateRef, ViewContainerRef } from "@angular/core";
import { Permission } from "../models/permission.model";

import { AuthenticationService } from "../services/authentication.service";

@Directive({
    selector: '[showPermitted]',
    standalone: false
})
export class ShowPermittedDirective {
  constructor(
    private templateRef: TemplateRef<any>,
    private authService: AuthenticationService,
    private viewContainer: ViewContainerRef
  ) {}

  @Input() set showPermitted(permission: Permission | PermissionWithCompany) {
    if(!permission) throw "You must provide a permission to check for in the ShowPermittedDirective";
    this.authService.getRolesAndPermissionsObservable().subscribe(permissions => {
      var isPermissionWithCompany = permission.hasOwnProperty("company");
      var actualPermission = isPermissionWithCompany ? (permission as PermissionWithCompany).permission : permission as Permission;
      var actualCompany = isPermissionWithCompany ? (permission as PermissionWithCompany).company : null;
      if(permissions?.hasPermission(actualPermission, actualCompany)) {
        this.viewContainer.clear();
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    });
  }  
}

class PermissionWithCompany {
  permission: Permission;
  company: string;
}